import React from 'react';
import { Grid } from '@mui/material';

import ContactsTable from 'app/main/modules/components/ContactsTable';
import PhonesListItem from 'app/main/submodules/phones/PhonesListItem';
import MailsListItem from 'app/main/submodules/mails/MailsListItem';
import SocialNetworksListItem from 'app/main/submodules/socialnetworks/SocialNetworksListItem';
import WebsitesListItem from 'app/main/submodules/websites/WebsitesListItem';

export default function CompaniesContactTab({ itemUid }: { itemUid: string }) {
	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 6, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={{ md: 6, xs: 12 }}>
						<ContactsTable
							contactModule="phones"
							parentModule="companies"
							parentUid={itemUid}
							itemLayout={PhonesListItem}
						/>
					</Grid>
					<Grid size={{ md: 6, xs: 12 }}>
						<ContactsTable
							contactModule="mails"
							parentModule="companies"
							parentUid={itemUid}
							itemLayout={MailsListItem}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 6, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={{ md: 6, xs: 12 }}>
						<ContactsTable
							contactModule="websites"
							parentModule="companies"
							parentUid={itemUid}
							itemLayout={WebsitesListItem}
						/>
					</Grid>
					<Grid size={{ md: 6, xs: 12 }}>
						<ContactsTable
							contactModule="socialnetworks"
							parentModule="companies"
							parentUid={itemUid}
							itemLayout={SocialNetworksListItem}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
